import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_slsodr_to_slsinv_consol_event_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    company_json: fromDatatype.JsonDatatypeInterface;
    branch_json: fromDatatype.JsonDatatypeInterface;
    customer_json: fromDatatype.JsonDatatypeInterface;
    salesman_json: fromDatatype.JsonDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    duration_day: fromDatatype.IntegerDatatypeInterface;
    visibility_setting: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
    recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
    is_recurring: boolean;
    rrule: fromDatatype.VarcharDatatypeInterface;
    recurring_event_params: fromDatatype.VarcharDatatypeInterface;
    recurring_update_type: fromDatatype.VarcharDatatypeInterface;
    processor_posting_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
    processor_posting_status: fromDatatype.VarcharDatatypeInterface;
    processor_posting_error: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_slsodr_to_slsinv_consol_event_hdr_RowClass
    implements bl_fi_slsodr_to_slsinv_consol_event_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    company_json: fromDatatype.JsonDatatypeInterface;
    branch_json: fromDatatype.JsonDatatypeInterface;
    customer_json: fromDatatype.JsonDatatypeInterface;
    salesman_json: fromDatatype.JsonDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    duration_day: fromDatatype.IntegerDatatypeInterface;
    visibility_setting: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
    recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
    is_recurring: boolean;
    rrule: fromDatatype.VarcharDatatypeInterface;
    recurring_event_params: fromDatatype.VarcharDatatypeInterface;
    recurring_update_type: fromDatatype.VarcharDatatypeInterface;
    processor_posting_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
    processor_posting_status: fromDatatype.VarcharDatatypeInterface;
    processor_posting_error: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
